import { useEffect } from 'react'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from '../../../../components/Form'
import Assignees from '../../../../components/Form/Items/Assignees'
import Attachments from '../../../../components/Form/Items/Attachment'
import Deadline from '../../../../components/Form/Items/Deadline'
import Description from '../../../../components/Form/Items/Description'
import Mandatory from '../../../../components/Form/Items/Mandatory'
import Title from '../../../../components/Form/Items/Title'
import UploadId from './Form/UploadId'

const DEFAULT_DATA = () => ({
  title: i18n.t('processes.process_settings.wizard.tasks.types.request_id.form.defaults.title', {
    emoji: '\u{1FAAA}',
  }),
  description: `${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_id.form.defaults.descriptions.1'
  )}<p><span><strong>${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_id.form.defaults.descriptions.2'
  )}</span></strong> \u{1FAAA}</p>${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_id.form.defaults.descriptions.3'
  )}`,
})

const Content = () => {
  const { associatedTaskItem: item, form, initializeForm } = useFormProvider()
  const defaultData = DEFAULT_DATA()

  useEffect(() => {
    initializeForm(DataCollectionCategories.identificationNumber, {
      task_type: TaskConfigurationTypes.DataCollection,
      task_type_configuration: {
        configuration_fields: [
          {
            resource: 'employee',
            categories: [{ category: DataCollectionCategories.identificationNumber }],
          },
        ],
      },
      title: item ? item.title : defaultData.title,
      instruction: item ? item.instruction : defaultData.description,
    })
  }, [])

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees onlyForAffectedUser readonly />,
        description: <Description />,
        uploadId: <UploadId />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
